module.exports = __webpack_public_path__ + "img/5.9d595876.png";